import axios from "~src/utils/axios";
import type { IItemString } from "~src/interfaces/commom";

const BASE_URL: IItemString = {
  // football: 'http://localhost:3003/v1/thesport',
  football: "https://v1.api-football.xyz",
  basketball: "https://bkb.api-football.xyz",
  tennis: "https://tn.api-football.xyz",
  badminton: "https://badminton.api-football.xyz",
  volleyball: "https://volleyball.api-football.xyz",
  esports: 'https://esports.api-football.xyz',
};

const getApiUrl = (sportType: string, path: string) => {
  return `${BASE_URL[sportType]}/${path}`;
};

export const getOddsByDate = async (
  sportType: string,
  siteId: number,
  ymd: string
) => {
  const url = getApiUrl(sportType, `${sportType}/odds/${siteId}/${ymd}`);

  return await axios.get(url);
};

export const getOddsLiveChanges = async (sportType: string, siteId: number) => {
  const url = getApiUrl(sportType, `${sportType}/odds-live-changes/${siteId}`);

  return await axios.get(url);
};

export const getOddsMatch = async (sportType: any, matchId: any) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/odd`);

  return await axios.get(url);
};

export const getOddsByLeague = async (
  sportType: string,
  leagueId: string,
  seasonId: string,
  siteId: number
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/odds/league/${leagueId}/season/${seasonId}/provider/${siteId}`
  );

  return await axios.get(url);
};
